import gql from 'graphql-tag';
import { orderPartyFragments } from './Order';
import { recurringOrderFragments } from './recurringOrderFragments';

export const recurringOrderSettingFragments = gql`
  fragment recurringOrderSettingFragments on RecurringOrderSetting {
    id
    active
    startDate
    endDate
    dateOffset
    interval
    lastDateCreatedOn
  }
`;

export const recurringOrderListFragments = gql`
  fragment recurringOrderListFragments on RecurringOrder {
    id
    payableAmount
    currencyCode
    customerParty {
      ...orderPartyFragments
    }
    recurringOrderSetting {
      ...recurringOrderSettingFragments
      nextDate
    }
    note
  }
  ${orderPartyFragments}
  ${recurringOrderSettingFragments}
`;

export const CREATE_RECURRING_ORDER = gql`
  mutation createRecurringOrder(
    $recurringOrderSetting: RecurringOrderSettingBase!,
    $note: String,
    $logo: ExistingAttachmentInput,
    $reference: String,
    $export: Boolean,
    $currencyCode: String!,
    $supplierParty: OrderPartyBase!,
    $customerParty: OrderPartyBase!,
    $orderDelivery: OrderDeliveryBase!,
    $bban: String,
    $iban: String,
    $taxAmount: Decimal!,
    $lineExtensionAmount: Decimal!,
    $taxExclusiveAmount: Decimal!,
    $taxInclusiveAmount: Decimal!,
    $payableAmount: Decimal!,
    $unitId: ID!,
    $customerId: ID!,
    $carId: ID,
    $projectId: ID,
    $departmentId: ID,
    $orderLines: [OrderLineBase!],
    $orderAllowanceCharges: [OrderAllowanceChargeBase!],
  ) {
    createRecurringOrder(
      input: {
        recurringOrder: {
          recurringOrderSetting: $recurringOrderSetting,
          note: $note,
          logo: $logo,
          reference: $reference,
          export: $export,
          currencyCode: $currencyCode,
          supplierParty: $supplierParty,
          customerParty: $customerParty,
          orderDelivery: $orderDelivery,
          bban: $bban,
          iban: $iban,
          taxAmount: $taxAmount,
          lineExtensionAmount: $lineExtensionAmount,
          taxExclusiveAmount: $taxExclusiveAmount,
          taxInclusiveAmount: $taxInclusiveAmount,
          payableAmount: $payableAmount,
          unitId: $unitId,
          customerId: $customerId,
          carId: $carId,
          projectId: $projectId,
          departmentId: $departmentId,
          orderLines: $orderLines,
          orderAllowanceCharges: $orderAllowanceCharges
        }
      }
    ) {
      recurringOrder {
        id
      }
    }
  },
`;

export const UPDATE_RECURRING_ORDER = gql`
  mutation updateRecurringOrder(
    $id: ID!,
    $recurringOrderSetting: RecurringOrderSettingBase!,
    $note: String,
    $reference: String,
    $export: Boolean,
    $logo: ExistingAttachmentInput,
    $currencyCode: String!,
    $supplierParty: OrderPartyBase!,
    $customerParty: OrderPartyBase!,
    $orderDelivery: OrderDeliveryBase!,
    $bban: String,
    $iban: String,
    $taxAmount: Decimal!,
    $lineExtensionAmount: Decimal!,
    $taxExclusiveAmount: Decimal!,
    $taxInclusiveAmount: Decimal!,
    $payableAmount: Decimal!,
    $customerId: ID!,
    $carId: ID,
    $projectId: ID,
    $departmentId: ID,
    $orderLines: [OrderLineBase!],
    $orderAllowanceCharges: [OrderAllowanceChargeBase!],
  ) {
    updateRecurringOrder(
      input: {
        recurringOrder: {
          id: $id,
          recurringOrderSetting: $recurringOrderSetting,
          note: $note,
          reference: $reference,
          export: $export,
          logo: $logo,
          currencyCode: $currencyCode,
          supplierParty: $supplierParty,
          customerParty: $customerParty,
          orderDelivery: $orderDelivery,
          bban: $bban,
          iban: $iban,
          taxAmount: $taxAmount,
          lineExtensionAmount: $lineExtensionAmount,
          taxExclusiveAmount: $taxExclusiveAmount,
          taxInclusiveAmount: $taxInclusiveAmount,
          payableAmount: $payableAmount,
          customerId: $customerId,
          carId: $carId,
          projectId: $projectId,
          departmentId: $departmentId,
          orderLines: $orderLines,
          orderAllowanceCharges: $orderAllowanceCharges
        }
      }
    ) {
      recurringOrder {
        ...recurringOrderFragments
      }
    }
  },
  ${recurringOrderFragments}
`;
